export class EnumUtils {

  static listEnumMembers<T = any>(tType: any): T[] {
    if (tType != null) {
      const uValues = Object.values(tType);
      return uValues as T[];
    }
  }
}
